import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getSession } from '@auth0/nextjs-auth0';
import SymbolPage from 'modules/SymbolPage';
import { symbols } from 'modules/SymbolPage/datas';
import { routes } from 'types/routes';
import { csrfPageRender } from 'utils/csrf';

export default SymbolPage;

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const { req, res, query, locale }: any = ctx;
  await csrfPageRender(req, res);
  const session = getSession(req, res);

  const { id }: any = query;

  if (!symbols[id]) {
    return {
      redirect: {
        permanent: false,
        destination: routes.symbol + '/BTC',
      },
    };
  }

  return {
    props: {
      csrfToken: req.csrfToken(),
      user: session?.user || null,
      ...(await serverSideTranslations(locale as string)),
    },
  };
}
